import { get, post } from "../GenericServices";

const ExportConsolidatedProjects = {
  searchProjects: (searchParams) => {
    return get(`export-consolidated-projects`, searchParams);
  },
  exportProjects: (data) => {
    return post("export-consolidated-projects", data);
  },
};

export default ExportConsolidatedProjects;
